import React from "react";
import type { LazyExoticComponent, ComponentType } from "react";

const Actuals = React.lazy(() => import("pages/Actuals"));
const ReportsDownload = React.lazy(() => import("components/reports/ReportsDownload"));
const BreakinLog = React.lazy(() => import("pages/BreakinLog"));
const ReportsPage = React.lazy(() => import("pages/ReportsPage"));
const Unauthorized = React.lazy(() => import("pages/Unauthorized"));
const PageNotAvailable = React.lazy(() => import("pages/PageNotAvailable"));
const FirstTimeUser = React.lazy(() => import("pages/FirstTimeUser"));
const AdminDashboard = React.lazy(() => import("pages/AdminDashboard"));
const CompareTool = React.lazy(() => import("pages/CompareTool"));
const SoundMouseWorkspace = React.lazy(() => import("pages/SoundMouseWorkspace"));

export interface AppRoute {
  path: string;
  label: string;
  component: LazyExoticComponent<ComponentType>;
  isPublic?: boolean;
}

export const routesConfig: AppRoute[] = [
  // --- PROTECTED ROUTES ---
  {
    path: "/actuals",
    label: "Actuals",
    component: Actuals,
  },
  {
    path: "/",
    label: "Actuals",
    component: Actuals,
  },
  {
    path: "/breakinlog",
    label: "Breakin Log",
    component: BreakinLog,
  },
  {
    path: "/reports",
    label: "Reports",
    component: ReportsPage,
  },
  {
    path: "/reports-download",
    label: "Download Reports",
    component: ReportsDownload,
  },
  {
    path: "/compare-tool",
    label: "Schedule Compare",
    component: CompareTool,
  },
  {
    path: "/soundmouse",
    label: "SoundMouse",
    component: SoundMouseWorkspace,
  },
  {
    path: "/soundmouse/dashboard",
    label: "SoundMouse Dashboard",
    component: SoundMouseWorkspace,
  },

  {
    path: "/admin",
    label: "Admin Dashboard",
    component: AdminDashboard,
  },

  // --- PUBLIC/STATUS ROUTES ---
  {
    path: "/first-login",
    label: "Welcome to Recon Tool",
    component: FirstTimeUser,
    isPublic: true,
  },
  {
    path: "/unauthorized",
    label: "Unauthorized",
    component: Unauthorized,
    isPublic: true,
  },
  {
    path: "*",
    label: "Page Not Available",
    component: PageNotAvailable,
    isPublic: true,
  },
];
